// 统一 API 前缀，由 .env.development / .env.production 注入，构建时自动切换。最后更新：2026-05-26
export const BaseApiUrl = process.env.VUE_APP_BASE_API || 'http://localhost:9291'

